"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceClientCache = void 0;
const converters_1 = require("../converters");
const ttlcache_1 = __importDefault(require("@isaacs/ttlcache"));
const MILLISECONDS_FACTOR = 1000;
class ServiceClientCache {
    cache;
    constructor(cacheMaxSize, cacheTTLInSeconds) {
        this.cache = new ttlcache_1.default({
            max: cacheMaxSize,
            ttl: cacheTTLInSeconds * MILLISECONDS_FACTOR,
            checkAgeOnGet: true,
        });
    }
    /**
     * Stores a feature assignment in a chache, removing the oldest entry if the
     * service has reached the cacheMaxSize limit.
     *
     * @param feature evaluationCriteria which be used o generate the key.
     * @param value feature assignmnet which will be stored.
     */
    put(feature, value) {
        const key = this.generateKeyFromObject(feature);
        this.cache.set(key, value);
    }
    /**
     * Gets the FeatureAssignment stored previously in the cache, generating a key using
     * the EvaluationCriteria properties and cleanning the onew which its the TTL, set
     * in cacheTTLInSeconds expired.
     *
     * @param feature EvaluationCriteria object that will be used to generate the key.
     * @returns FeatureAssignment or undefined.
     */
    get(feature) {
        const key = this.generateKeyFromObject(feature);
        return this.cache.get(key);
    }
    /**
     * Method to generate a string key used to map the values, current implementation
     * uses a template to avoid ordering issues.
     *
     * @param evaluationCriteria
     * @returns string representation of the key.
     */
    generateKeyFromObject(evaluationCriteria) {
        return (0, converters_1.evaluationCriteriaToKey)(evaluationCriteria);
    }
}
exports.ServiceClientCache = ServiceClientCache;
